import React, { useEffect, useState, useContext } from "react"
import { useParams, useHistory } from "react-router-dom";
import { Button, Col, Input, Label, Row, Table } from "reactstrap";
import Header from "../shared/Header";
import Requester from "../shared/Requester";
import Swal from "sweetalert2";
// import { useContext } from "react/cjs/react.development";
import { SessionContext } from "../shared/session";

const MODULES_MEDIACION = [
    {
        label: 'Usuarios',
        name: 'usuarios'
    },
    {
        label: 'Clientes',
        name: 'clientes'
    },
    {
        label: 'Información Preliminar',
        name: 'infoPreliminar'
    }, {
        label: 'Actos Previos',
        name: 'actosPrevios'
    }, {
        label: 'Tramitación',
        name: 'tramitacion'
    }, {
        label: 'Pago y Facturación',
        name: 'pagoFacturacion'
    }, {
        label: 'Solicitud de Folio',
        name: 'solicitudFolio'
    }, {
        label: 'Firma',
        name: 'firma'
    }, {
        label: 'Actos Post-Firma',
        name: 'actosPostFirma'
    },
    {
        label: 'Entrega',
        name: 'entrega'
    }, {
        label: 'Archivo y Copias',
        name: 'copiasArchivo'
    }
]

const MODULES_CORREDURIA = [...MODULES_MEDIACION.map(
    m => m.name === 'actosPostFirma' ? {
        label: 'Actos Post-Firma',
        name: 'actosPostFirmaCorreduria'
    } : m)]

const MODULES_PLD = [
    { label: 'Expedientes PLD', name: 'expedientesPLD' },
    { label: 'Sujetos PLD', name: 'sujetosPLD' },
    { label: 'Documentos PLD', name: 'documentosPLD' },
]

function shouldShowPldModules(unidad) {
    // Fase 7 — interino según Integracion-PLD.md
    return Boolean(unidad)
    // TODO Fase 8: restringir Mediador/Correduría al flag Escenario A en Unidad
    // if (unidad.tipo === 'PLD') return true
    // if (unidad.tipo === 'Mediador Privado' || unidad.tipo === 'Correduría') {
    //     return Boolean(unidad.escenarioA)
    // }
    // return false
}

function Permisos() {

    const [permiso, setPermiso] = useState({ unidadNegocio: '' })
    const history = useHistory()

    const { usuarioId } = useParams()
    const session = useContext(SessionContext)

    const [usuario, setUsuario] = useState({})
    const [saving, setSaving] = useState(false)

    useEffect(() => {

        async function fetchPermiso() {
            try {
                const response = await Requester.get(`usuarios/permisos/${usuarioId}/${session.unidad._id}`)
                setPermiso({
                    unidadNegocio: session.unidad._id,
                    ...response.data
                })
            } catch (e) {
                if (e?.response?.status === 409 && e?.response?.data?.error === 'LIMIT_REACHED') {
                    Swal.fire({
                        icon: 'error',
                        title: 'Límite de usuarios alcanzado',
                        text: `Esta unidad de negocio ya tiene el máximo de ${e.response.data.maxActiveUsers} usuarios activos permitidos.`,
                        confirmButtonColor: '#6c757d'
                    })
                    setPermiso({ unidadNegocio: '' })
                } else {
                    throw e;
                }
            }
        }

        if (session.unidad) {
            fetchPermiso()
        }

    }, [session.unidad, usuarioId])

    useEffect(() => {

        async function fetchUsuario() {
            const response = await Requester.get(`usuarios/${usuarioId}`)
            setUsuario(response.data)
        }

        fetchUsuario();

    }, [usuarioId])


    function handleChangePermiso(module) {
        return function (e) {
            setPermiso({ ...permiso, [module.name]: e.target.value })
        }
    }

    function handleChangeAdmin(e) {
        setPermiso({ ...permiso, admin: e.target.checked })
    }

    const baseModules = session?.unidad?.tipo === 'Correduría'
        ? MODULES_CORREDURIA
        : MODULES_MEDIACION

    let modules = []

    if (session?.unidad?.tipo === 'PLD' && session?.unidad?.actividad === 'inmobiliaria') {
        modules = [...MODULES_PLD, {
            label: 'Usuarios',
            name: 'usuarios'
        }]
    } else {
        modules = shouldShowPldModules(session?.unidad)
        ? [...baseModules, ...MODULES_PLD]
        : baseModules
    }

    async function handleClickSave() {
        setSaving(true)
        try {
            await Requester.post(`usuarios/permisos/${usuarioId}/${permiso.unidadNegocio}`, permiso)
            Swal.fire({
                icon: 'success',
                title: 'Guardado',
                confirmButtonText: 'Continuar',
                confirmButtonColor: '#6c757d',
                timer: 1200
            })
        } catch (err) {
            if (err?.response?.status === 409 && err?.response?.data?.error === 'NO_ADMIN') {
                Swal.fire({
                    icon: 'error',
                    title: 'Se requiere al menos un administrador',
                    text: 'No es posible guardar porque la unidad de negocio quedaría sin ningún administrador.',
                    confirmButtonColor: '#6c757d'
                })
            } else {
                throw err;
            }
        } finally {
            setSaving(false)
        }
    }

    return (
        <div>
            <Header>Permisos</Header>
            <div>
                <Row>
                    <Col xs='6'>Estas editando los permisos de: <strong>{usuario.nombre}</strong></Col>
                    {
                        permiso._id ? (
                            <Col xs='6'>
                                <div style={{ display: 'flex', flexDirection: 'row', flexGrow: 1 }}>
                                    <Label for="admin">Administrador</Label>
                                    {' '}
                                    <Input type="checkbox"
                                        checked={permiso.admin}
                                        onChange={handleChangeAdmin}></Input>
                                </div>
                            </Col>
                        )
                        : (
                            <Col xs='6'>
                                <div style={{ display: 'flex', flexDirection: 'row', flexGrow: 1 }}>Permisos insuficientes</div>
                                <Button color="secondary" onClick={() => history.goBack()}>Regresar</Button>
                            </Col>
                        )
                    }
                </Row>
                <br />
                {
                    permiso._id ?
                        <React.Fragment>
                            {
                                !permiso.admin ?
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th>Módulo</th>
                                                <th>Escritura</th>
                                                <th>Lectura</th>
                                                <th>Ninguno</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                modules.map(m => (
                                                    <tr key={m.name}>
                                                        <td>{m.label}</td>
                                                        <td>
                                                            <input type="radio"
                                                                value="write"
                                                                checked={permiso[m.name] === 'write'} onChange={handleChangePermiso(m)}></input>
                                                        </td>
                                                        <td>
                                                            <input type="radio"
                                                                value="read"
                                                                checked={permiso[m.name] === 'read'} onChange={handleChangePermiso(m)}></input>
                                                        </td>
                                                        <td>
                                                            <input type="radio"
                                                                value="none"
                                                                checked={permiso[m.name] === 'none'} onChange={handleChangePermiso(m)}></input>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table> : null
                            }
                            <br />
                            <br />
                            <Row>
                                <Col xs="10"></Col>
                                <Col xs="2">
                                    <Button color="secondary"
                                        onClick={handleClickSave}
                                        disabled={saving}>Guardar</Button>
                                </Col>
                            </Row>
                        </React.Fragment> : null
                }

            </div>
        </div>
    )

}

export default Permisos